// extracted by mini-css-extract-plugin
export default {"hola_pros":"hola_pros___TGyje","card":"card___Mieji","card_title":"card_title___n_sKk","card_anim":"card_anim___DRscc"};